module.exports = __webpack_public_path__ + "assets/chevron.ff1ae75d.svg";